module.exports = __webpack_public_path__ + "static/img/shirt.4766f1a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shirt.gif
// module id = 455
// module chunks = 1